import { Head, Link, useForm } from '@inertiajs/react'
import AuthPanel from '../../components/AuthPanel'
import TextField from '../../components/TextField'
import { buttonClass, linkClass } from '../../components/ui'

export default function PasswordsEdit({ token }: { token: string }) {
  const form = useForm({ password: '', password_confirmation: '' })

  return (
    <>
      <Head title="Choose a new password" />
      <AuthPanel
        title="Choose a new password"
        description="Use at least 10 characters."
        footer={<Link href="/session/new" className={linkClass}>Back to sign in</Link>}
      >
        <form
          className="space-y-5"
          aria-busy={form.processing}
          onSubmit={(e) => {
            e.preventDefault()
            form.put(`/passwords/${token}`)
          }}
        >
          <TextField label="New password" name="password" type="password" autoComplete="new-password" required
            value={form.data.password} error={form.errors.password} onChange={(v) => form.setData('password', v)} />
          <TextField label="Confirm new password" name="password_confirmation" type="password" autoComplete="new-password" required
            value={form.data.password_confirmation} error={form.errors.password_confirmation} onChange={(v) => form.setData('password_confirmation', v)} />
          <button type="submit" className={`${buttonClass} w-full`} disabled={form.processing}>
            {form.processing ? 'Saving password…' : 'Save password'}
          </button>
        </form>
      </AuthPanel>
    </>
  )
}
